// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"a516c398","455":"589754b8","829":"43262b0c"}[chunkId] + ".chunk.js";
};